/********************************************************************
 * ADOBE CONFIDENTIAL
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { PlaceOrderResponse } from '@/order/types';

export class PlaceOrderError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PlaceOrderError';
  }
}

export const handlePlaceOrderError = (
  errors: NonNullable<PlaceOrderResponse['errors']>
) => {
  const errorMessage = errors.map((e: any) => e.message).join(' ');
  throw new PlaceOrderError(errorMessage);
};
